import React from "react";
import { siteData } from "../data/mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { ArrowRight } from "lucide-react";

const FAQ = () => {
  const { faq } = siteData;
  return (
    <section id="faq" className="py-16 sm:py-20 lg:py-32 relative">
      <div className="max-w-[900px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3">
            <span className="eyebrow-line" />
            <span className="text-[11px] tracking-[0.32em] uppercase text-[#5EC7F5]">
              {faq.eyebrow}
            </span>
            <span className="eyebrow-line" />
          </div>
          <h2 className="font-display text-[32px] sm:text-[44px] md:text-[52px] lg:text-[60px] leading-[1.02] sm:leading-[0.98] mt-6 text-gradient-title uppercase">
            {faq.title}
          </h2>
          <p className="font-italic-serif text-[20px] sm:text-[26px] md:text-[32px] lg:text-[36px] mt-2 text-gradient-blue">
            {faq.italic}
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10 sm:mt-12 space-y-1">
          {faq.items.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-b hairline"
            >
              <AccordionTrigger className="font-display text-left text-[17px] sm:text-[20px] md:text-[22px] leading-snug text-white hover:no-underline py-5 sm:py-6 [&[data-state=open]>svg]:text-[#5EC7F5] gap-3">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 text-[13.5px] sm:text-[14.5px] leading-relaxed pb-6 pr-2">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="flex justify-center mt-12 sm:mt-14">
          <a
            href="#register"
            className="inline-flex items-center gap-2 px-6 sm:px-7 py-3.5 rounded-full text-[#5EC7F5] border border-[#5EC7F5]/40 hover:bg-[#5EC7F5]/10 transition-colors text-[13px] sm:text-sm tracking-[0.14em] uppercase"
          >
            Reserve My Seat <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
